export default {
  toasts: {
    load_error: 'Échec du chargement de la configuration de paiement',
    rails_saved: 'Rails de paiement enregistrés',
    gateway_registered: 'Passerelle enregistrée',
    redact_failed: 'Échec de la suppression de la passerelle',
    gateway_redacted: 'Passerelle supprimée',
    sca_provisioned: 'Enregistrement 3DS2 créé',
    company_assigned: 'Restaurant assigné',
    default_set: 'Passerelle par défaut définie — les nouveaux restaurants y seront automatiquement assignés',
    default_failed: 'Échec de la définition de la passerelle par défaut',
    primary_switched: 'Passerelle principale changée en {{gateway}}',
    primary_switch_failed: 'Échec du changement de passerelle principale',
  },
  custody: {
    title: 'Qui traite les paiements',
    description:
      'Décidé une seule fois, lors du premier enregistrement du mode de paiement, puis verrouillé : avec sa propre passerelle, le partenaire détient les fonds ; sur le compte Adyen de FoodAmigos, FoodAmigos les détient et verse la part du partenaire chaque mois.',
    options: {
      provider: 'Passerelle propre au partenaire',
      platform: 'FoodAmigos traite les paiements',
    },
    locked_notice: 'Verrouillé sur « {{custodian}} » par la configuration des paiements — non modifiable.',
    pick_first: "Choisissez d'abord qui traite les paiements.",
    lock_confirm: {
      title: 'Verrouiller les paiements sur « {{custodian}} » ?',
      description:
        'En enregistrant, vous déterminez maintenant qui détient les fonds de ce partenaire, et cela est irréversible — ni ici, ni par le support. Le mode de paiement peut encore être modifié plus tard ; le gestionnaire des paiements ne le peut pas.',
      confirm: 'Verrouiller et enregistrer',
    },
  },
  rails: {
    title: 'Rail de paiement',
    description:
      'Le processeur utilisé par ce partenaire — un seul à la fois. Les restaurants ne peuvent basculer que vers le rail sélectionné ici, et un rail ne peut être remplacé tant que des restaurants y débitent encore des paiements.',
    save: 'Enregistrer le rail',
    multiple_warning:
      "Ce partenaire utilise encore plusieurs rails ({{rails}}). L'enregistrement ne conserve que celui sélectionné ci-dessus ; les autres sont supprimés, et la modification est refusée si un restaurant y débite encore des paiements.",
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Passerelle locale via Spreedly',
    },
    platform_stripe_unavailable: "Stripe sur les comptes FoodAmigos n'est pas encore disponible.",
    platform_custody_notice: 'Non disponible lorsque FoodAmigos traite les paiements.',
    provider_custody_adyen_notice:
      'Non disponible lorsque le partenaire utilise son propre prestataire — Adyen est le canal de traitement FoodAmigos.',
  },
  spreedly_section_title: 'Configuration Spreedly',
  gateways: {
    title: 'Passerelles',
    description:
      "Les propres comptes PSP du partenaire. La totalité du débit est réglée sur l'acquéreur de la passerelle sélectionnée.",
    register: 'Enregistrer une passerelle',
    empty: 'Aucune passerelle enregistrée',
    columns: {
      gateway: 'Passerelle',
      status: 'Statut',
      sca: '3DS2',
      companies: 'Restaurants',
    },
    statuses: {
      active: 'Active',
      redacted: 'Supprimée',
    },
    sca: {
      sandbox: 'Bac à sable 3DS2',
      live: '3DS2 en production',
      none: 'Pas de 3DS2',
    },
    default_tag: 'Par défaut',
    actions: {
      make_default: 'Définir par défaut',
      check: 'Lancer une vérification…',
      sca_provision: 'Configurer 3DS2…',
      sca_manage: 'Enregistrement 3DS2…',
      redact: 'Supprimer la passerelle',
    },
  },
  redact_confirm: {
    title: 'Supprimer {{gateway}} ?',
    description:
      'Les identifiants sont supprimés chez Spreedly et ne peuvent pas être restaurés. {{count}} restaurant(s) assigné(s) débitent encore via cette passerelle — tant que des restaurants y sont assignés, la suppression est refusée et une nouvelle confirmation vous est demandée.',
    redact: 'Supprimer',
    force_title: 'Supprimer {{gateway}} quand même ?',
    force_description:
      "{{count}} restaurant(s) sont encore assignés à cette passerelle. La supprimer maintenant refusera leur paiement tant que chacun n'aura pas été assigné à une autre passerelle. Cette action est irréversible.",
    force_redact: 'Supprimer quand même',
  },
  companies: {
    title: 'Restaurants',
    description: 'Le processeur utilisé par chaque restaurant, et son assignation de passerelle Spreedly.',
    empty: 'Aucun restaurant',
    no_gateway: 'Aucune',
    unassigned: 'Non assigné',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: "Échec de l'assignation automatique",
    assign: 'Assigner',
    reassign: 'Réassigner',
    columns: {
      restaurant: 'Restaurant',
      primary_gateway: 'Passerelle principale',
      spreedly: 'Passerelle Spreedly',
    },
    switch_primary_to: 'Basculer vers {{gateway}}',
    assign_modal: {
      title: 'Assigner {{company}} à une passerelle',
      assign: 'Assigner',
      gateway: 'Passerelle',
      make_primary: 'Faire aussi de Spreedly la passerelle principale',
      make_primary_hint: "Les débits ne transitent par Spreedly que tant qu'elle est la passerelle principale.",
    },
  },
  register_modal: {
    title: 'Enregistrer une passerelle',
    register: 'Enregistrer',
    gateway_type: 'Type de passerelle',
    gateway_type_placeholder: 'Rechercher dans le catalogue Spreedly…',
    auth_mode: "Mode d'authentification",
    no_credentials: 'Ce type de passerelle ne nécessite aucun identifiant (bac à sable Spreedly).',
    description: 'Description',
    description_placeholder: 'ex. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID marchand acquéreur',
    acquirer_hint: 'Facultatif — requis avec le MCC',
    mcc: 'MCC',
    mcc_hint: '4 chiffres, ex. 5812',
    make_default: 'Utiliser comme défaut du partenaire',
    make_default_hint:
      'Les nouveaux restaurants du partenaire, ainsi que ceux sans passerelle, y sont rattachés. Laissez décoché s’il s’agit de l’acquéreur propre à un seul restaurant.',
  },
  sca_modal: {
    title: 'Enregistrement 3DS2 — {{gateway}}',
    provision: 'Approvisionner',
    irreversible_warning:
      "Irréversible : ni le profil marchand ni le fournisseur SCA ne peuvent être modifiés ou supprimés par la suite. Un mauvais BIN acquéreur n'apparaît qu'au moment du débit. Vérifiez chaque valeur avec la banque acquéreuse avant l'approvisionnement.",
    already_provisioned:
      "Déjà approvisionné (jeton fournisseur {{token}}). Approvisionner à nouveau renvoie l'enregistrement existant sauf si « Recréer » est activé.",
    type: {
      label: 'Type de fournisseur',
      hint: "« Test » simule des résultats d'authentification et est refusé en production.",
      test: 'Test (bac à sable SCA)',
      live: 'Production (Spreedly 3DS2 Global)',
    },
    country: {
      hint: "Le pays sous lequel la banque acquéreuse a enregistré ce marchand — pas nécessairement celui où le partenaire est constitué. S'applique à chaque réseau de cartes ci-dessous.",
      differs_warning:
        "Ce n'est pas le pays du partenaire ({{country}}). Corrigez si l'acquéreur a enregistré le marchand ailleurs ; sinon, vérifiez-le, car un profil marchand ne peut pas être modifié une fois créé.",
    },
    network_placeholder: 'Réseau de carte',
    add_network: 'Ajouter un réseau de carte',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID marchand acquéreur',
      acquirer_bin: 'BIN acquéreur',
      mcc: 'MCC',
      merchant_name: 'Nom du marchand',
      country_code: 'Pays (ISO-2)',
      merchant_url: 'URL du marchand',
    },
    recreate: {
      label: "Recréer l'inscription",
      hint: 'Abandonne définitivement le profil marchand et le fournisseur SCA actuels et en crée de nouveaux.',
    },
  },
  check_modal: {
    title: 'Vérifier la passerelle — {{gateway}}',
    run: 'Lancer la vérification',
    done: 'Terminé',
    failed: "La vérification n'a pas pu être exécutée.",
    types: {
      verify: "Vérifier (aucun mouvement d'argent)",
      test_payment: 'Paiement test',
    },
    verify_unsupported:
      'Ce type de passerelle ne prend pas en charge la vérification — effectuez plutôt un paiement test.',
    test_payment_warning:
      "Un débit réel est effectué sur une passerelle en production et immédiatement remboursé. Sur les passerelles des marchés SCA, l'émetteur peut refuser le test non-3DS — cela prouve tout de même que les identifiants ont atteint l'acquéreur.",
    amount: 'Montant',
    amount_help: 'Entre 1,00 et 5,00',
    check_passed: 'Vérification réussie',
    check_failed: 'Vérification échouée — voir les étapes ci-dessous',
    legs: {
      verify: 'Vérification',
      purchase: 'Débit',
      credit: 'Remboursement',
    },
    leg_passed: 'Réussi',
    leg_failed: 'Échoué',
  },
  card_fields: {
    script_failed: "Le script Spreedly n'a pas pu être chargé. Vérifiez le réseau et réessayez.",
    full_name: 'Nom du titulaire de la carte',
    number: 'Numéro de carte',
    expiry: "Date d'expiration",
    cvv: 'CVV',
  },
};
